export const TYPES = {
	AUTH: {
		REGISTER: {
			ERROR: 'There was an error or this email is already in use',
			SUCCESS:
				'Registration successful, please check your email and click the link to verify your email address'
		},
		LOGIN: {
			ERROR: 'Incorrect email and/or password'
		},
		RECOVER: {
			GENERAL: 'If an account exists you will receive a rest link in your email'
		},
		ACTIVATE: {
			ERROR: 'Could not activate account please try again',
			SUCCESS: 'Activation successful'
		},
		RESET: {
			ERROR: 'Could not reset password please try again',
			SUCCESS: 'Password reset successful'
		}
	},
	GENERIC: 'Something went wrong, refresh and try again.',
	NEWSLETTER: {},
	CART: {
		NO_VARIANT_SELECTED: 'You must  select product options to continue',
		VARIANT_UNAVAILABLE: 'This variant is unavailable',
		UPDATED: 'Your cart has been updated'
	},
	STORES: {
		FAILED_GET: 'Could not get store'
	},
	CUSTOMREQUEST: {
		SUBMITTED: 'Your custom request has been submitted.'
	},
	RETURNS: {
		SUCCESS: 'Return Request Submitted',
		EMAIL_INVALID: 'Please enter a valid email address'
	},
	MEDIA: {
		LIFESTYLE: {
			ALT: 'lifestyle'
		},
		PERSONALIZE: {
			ALT: 'personalize'
		},
		EXTERNAL_VIDEO: 'external_video',
		IMAGE: 'image',
		VIDEO: 'video',
		YOUTUBE: 'youtube'
	},
	PHASED_OUT: 'T'
};
